
import _ from 'lodash'
import {
    CASHBACK_TYPE,
    ERROR_WRONG_INFORMATIONS,
    MIN_BASKET,
    NO_POINT,
    NO_PRODUCTS,
    NO_SHOPS,
    POINT,
    PRODUCT_TYPE,
    SAME_POINT,
    SUCCESS_UPDATE_TEXT
} from '../../constants'
import { isStringNotNull } from '../../utils/tools'
import { showNotification } from '../../components/Notification/Notification.view'
import {
    addLoyaltyVersion,
    addOfferedProducts,
    addVersionShops,
    deleteLoyaltyVersion,
    updateLoyaltyConfiguration,
    updateLoyaltyVersion,
    getLoyaltyPrograms
} from '../../apis/backend'

export const handleChange = (event, validationMessage, setValidationMessage) => {
    const { id, value } = event.target;

    let statusError = 'is-invalid';

    statusError = value !== null && value !== '' ? 'is-valid' : 'is-invalid';
    setValidationMessage({
        ...validationMessage,
        [id]: { ...validationMessage[id], text: statusError }
    });
};

export const changeFidelityProgram = async (
    openErrorModal,
    stateObj,
    setStateObj
) => {
    const { enabledCashBack, enabledProduct, limit, cashBackPointsPerEuro, minBasket, pointName, pointsPerEuro } = stateObj;
    const minBasketValue = isStringNotNull(minBasket) ? parseFloat(minBasket) : 0;

    const newConfiguration = {
        enabled: stateObj.selected === 0 ? enabledCashBack : enabledProduct,
        type: stateObj.selected === 0 ? CASHBACK_TYPE : PRODUCT_TYPE
    }
    const pointsPerEuroForStorage = parseFloat((cashBackPointsPerEuro / limit));

    _.assign(newConfiguration, stateObj.selected === 0 ? {
        cashbackConfig: {
            limit: parseInt(limit, 10),
            pointsPerEuro: pointsPerEuroForStorage,
            minBasket: parseInt(minBasketValue, 10)
        }
    } : {
        productConfig: {
            pointName,
            pointsPerEuro: Math.round(pointsPerEuro * 10) / 10
        }
    });

    try {
        setStateObj({ isLoading: true, minBasket: minBasketValue });
        if (
            stateObj.selected === 0 && (!isStringNotNull(limit) ||
                !isStringNotNull(cashBackPointsPerEuro))
        )
            openErrorModal(ERROR_WRONG_INFORMATIONS);
        else if (minBasketValue < 0) {
            openErrorModal(MIN_BASKET);
        }
        else {
            await updateLoyaltyConfiguration(newConfiguration)
            showNotification(
                'light',
                'ltr',
                'primary',
                SUCCESS_UPDATE_TEXT,
                `${stateObj.selected === 0 ? 'Les paramètres de programme de fidélité ont bien été modifiés.' : 'La configuration de la fidélité par produit a bien été modifiée.'}`
            );
        }
    } catch (e) {
        console.error(JSON.stringify(e, null, 2));
        setStateObj({ isLoading: false });
    }
    setStateObj({ isLoading: false });
};
export const handleClick = (event, index, setStateObj, title) => {
    setStateObj({ config: title, title });
};
export const handleVersionClick = (version, setStateObj, versionTitle) => {
    setStateObj({ versionConfig: versionTitle, versionTitle, version, newVersion: version });
};
export const addVersion = async (stateObj, setStateObj, openErrorModal) => {
    const { versionName, rules, defaultVersion = false, key = '' } = stateObj.version

    if (
        (!isStringNotNull(versionName) ||
            (!isStringNotNull(rules?.minBasket.toString())))
    )
        openErrorModal(ERROR_WRONG_INFORMATIONS);
    else if (rules?.minBasket < 0) {
        openErrorModal(MIN_BASKET);
    }
    else {
        setStateObj({ isLoading: true });
        try {
            if (!isStringNotNull(key)) {
                await addLoyaltyVersion(versionName, parseFloat(rules?.minBasket), defaultVersion);

            }
            else {
                await updateLoyaltyVersion(versionName, parseInt(rules?.minBasket, 10), defaultVersion, key);
                setStateObj({ versionTitle: versionName, versionConfig: versionName });
            }
            setStateObj({ updateVersions: true });
            showNotification(
                'light',
                'ltr',
                'primary',
                SUCCESS_UPDATE_TEXT,
                `La version ${versionName} a bien été  ${!isStringNotNull(key) ? 'ajoutée' : 'modifiée'}`
            );
            setStateObj({ isLoading: false, isOpenConfiguration: false });
        }
        catch (e) {
            setStateObj({ isLoading: false });
        }
    }
}
export const handleRemoveVersion = (stateObj, setStateObj, showModal) => {
    const modalData = {
        color: 'danger',
        title: `Êtes-vous sûr(e) de vouloir supprimer la version ${stateObj.version?.versionName}`,
        showCancelBtn: true,
        btnColor: 'danger',
        onClick: async () => {
            try {
                await deleteLoyaltyVersion(stateObj.version?.key);
                setStateObj({ updateVersions: true });
                showNotification(
                    'light',
                    'ltr',
                    'primary',
                    SUCCESS_UPDATE_TEXT,
                    `La version ${stateObj.version?.versionName} a bien été supprimée`
                );
                setStateObj({ versionConfig: '', version: {}, versionTitle: '' });
            } catch (e) {
                setStateObj({ isLoading: false });

            }

            showModal(null);
        },
        btnTxt: 'Supprimer'
    };
    showModal(modalData);
};
export const handleChangeCheckbox = (stateObj, setStateObj, shopId) => {
    let { shops = [] } = stateObj.version;

    if (shops.includes(shopId)) {
        shops = shops.filter(shop => shop !== shopId)
    }
    else {
        shops.push(shopId);
    }
    setStateObj({ version: { ...stateObj.version, shops } });
};


const renderMissingProductsModalContent = (missingProductsForAddedShops = {}, allShops) => (
    <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '0 15px' }}>
        <p><strong>Des produits sont manquants sur certains restaurants.</strong></p>
        <p>Pour garantir la cohérence du programme de fidélité, ces produits seront retirés du programme global tant qu’ils ne sont pas disponibles sur tous les restaurants sélectionnés.</p>
        <p>Veuillez vérifier les produits manquants ci-dessous avant de confirmer l’opération.</p>

        {Object.entries(missingProductsForAddedShops || {}).map(([shopId, steps]) => (
            <div key={shopId} style={{ marginTop: 16 }}>
                <p><strong>Restaurant «{allShops[shopId].name}» :</strong></p>
                {Object.entries(steps || {}).map(([stepNumber, products]) => (
                    <div key={stepNumber} style={{ marginLeft: 12 }}>
                        <p>Palier {stepNumber} :</p>
                        <ul style={{ paddingLeft: 20 }}>
                            {products.map((p) => (
                                <li key={p.productKey}>
                                    {p.name ? `${p.name}` : ''}
                                    {` (${p.productKey})`}

                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        ))}
    </div>
);

export const addParticipatingShops = async (stateObj, setStateObj, openErrorModal, showModal, allShops, confirmedUpdateAction, resetProduct) => {
    const { shops = [], key } = stateObj.version
    if (!shops?.length) {
        openErrorModal(NO_SHOPS)
        return
    }
    try {
        showModal(null)
        setStateObj({ isLoading: true })
        const response = await addVersionShops(shops, key, confirmedUpdateAction, resetProduct)
        setStateObj({ isLoading: false })
        if (response.status === 201) {
            showNotification(
                'light',
                'ltr',
                'primary',
                SUCCESS_UPDATE_TEXT,
                `Les restaurants participants au programme de fidélité ont bien été modifiés`
            )
            setStateObj({ isLoading: false, isOpenShops: false, updateVersions: true });
            return;
        }
        if (response.status === 200) {
            const { missingProductsForAddedShops = {} } = response.data
            const modalData = {
                color: 'primary',
                children: renderMissingProductsModalContent(missingProductsForAddedShops, allShops),
                btnColor: 'primary',
                onClick: () => {
                    addParticipatingShops(stateObj, setStateObj, openErrorModal, showModal, allShops, true)
                },
                btnTxt: `J'ai compris`,
                showSecondaryBtn: true,
                onSecondaryBtnClick: () => {
                    showInfoModal(stateObj, setStateObj, openErrorModal, showModal, allShops)
                },
                secondaryBtnText: 'Réinitialiser le programme',
                header: true,
                title: '! ATTENTION !',
                width: '500px',
                showCancelBtn: true,
            }
            showModal(modalData)
        }
    } catch (e) {
        setStateObj({ isLoading: false })
    }
}
export const showInfoModal = (stateObj, setStateObj, openErrorModal, showModal, allShops) => {
    const modalData = {
        color: 'primary',
        message: `La validation va supprimer définitivement le programme de fidélité. 
              Cette action est irréversible. Souhaitez-vous continuer ?`,
        btnColor: 'primary',
        onClick: () => {
            addParticipatingShops(stateObj, setStateObj, openErrorModal, showModal, allShops, false, true)
        },
        btnTxt: `Confirmer`,
        header: true,
        title: '! ATTENTION !',
        width: '430px',
        showCancelBtn: true,
    };
    showModal(modalData);


}
export const updatePoint = (value, isDelete, setStateObj, stateObj, openErrorModal) => {
    let newProgram;
    if (value) {
        if (isDelete) {
            newProgram = _.omit(stateObj.version.program, value);
        } else {
            if (parseInt(value, 10) > 0) {
                if (_.keys(stateObj.version.program).indexOf(value.toString()) < 0) {
                    const newPoints = { points: value };
                    newProgram = _.assign({}, stateObj.version.program || {}, { [value]: newPoints });
                }
                else {
                    openErrorModal(SAME_POINT);
                    newProgram = _.assign({}, stateObj.version.program || {});
                }
            }
            else {
                openErrorModal(POINT);
            }

        }
        setStateObj({ ...stateObj, version: { ...stateObj.version, program: newProgram }, newVersion: { ...stateObj.newVersion, program: newProgram }, newPoints: '' });
    }

};
export const handlePointClick = (points, setStateObj, stateObj) => {
    setStateObj({ ...stateObj, openPoint: stateObj.openPoint === points ? null : points });
};
export const getCommonProducts = (shopIds, menus) => {
    if (!menus || !shopIds || !shopIds.length) {
        return [];
    }

    const EXCLUDED_SECTION_KEYS = [
        'customSplashIngredients',
        'customAdditionIngredients',
        'customBiborneIngredients',
        'customDishopIngredients',
        'customMenuPosNewProducts',
    ];
    const shopProducts = shopIds.map((shopId) => {
        const menu = menus[shopId];
        if (!menu?.sections) return [];

        return Object.values(menu.sections)
            .filter(
                (section) =>
                    section?.key &&
                    !EXCLUDED_SECTION_KEYS.includes(section.key),
            )
            .flatMap((section) =>
                Object.values(section.products || {}).map((product) => ({
                    key: product.key,
                    ref: product.ref,
                    name: product.name,
                    sectionKey: section.key,
                    sectionName: section.name,
                })),
            );
    });

    const commonProducts = shopProducts.reduce((acc, products, index) => {
        if (index === 0) return products;

        return acc.filter((product) =>
            products.some((p) => p.key === product.key),
        );
    }, []);

    const groupedSections = commonProducts.reduce((acc, product) => {
        let section = acc.find((s) => s.key === product.sectionKey);

        if (!section) {
            section = {
                key: product.sectionKey,
                name: product.sectionName,
                products: [],
            };
            acc.push(section);
        }

        section.products.push({
            key: product.key,
            ref: product.ref,
            name: product.name,
        });

        return acc;
    }, []);

    return groupedSections.filter(
        (section) => section.products && section.products.length > 0,
    );
};


export const handleCheckboxChange = (productKey, stateObj, setStateObj) => {
    const updatedProgram = { ...stateObj.version.program };
    const pointIndex = Object.values(updatedProgram).findIndex(program => program?.points === stateObj.openPoint);

    if (pointIndex !== -1) {
        const updatedProducts = { ...Object.values(updatedProgram)[pointIndex].products };
        if (updatedProducts[productKey]) {
            delete updatedProducts[productKey];
        } else {
            updatedProducts[productKey] = { productKey };
        }
        Object.values(updatedProgram)[pointIndex].products = updatedProducts;
    }
    const newVersion = {
        ...stateObj,
        version: {
            ...stateObj.version,
            program: updatedProgram
        },
    };
    setStateObj(newVersion);
};

export const addProducts = async (stateObj, setStateObj, openErrorModal) => {
    const { program = {}, key = '' } = stateObj.version;
    if (_.size(program) === 0) {
        openErrorModal(NO_POINT);
    } else {
        const allPointsHaveProducts = _.every(program, point => _.size(point?.products) > 0);

        if (!allPointsHaveProducts) {
            openErrorModal(NO_PRODUCTS);
        } else {
            try {
                setStateObj({ isLoading: true });
                await addOfferedProducts(Object.values(program), key);
                showNotification(
                    'light',
                    'ltr',
                    'primary',
                    SUCCESS_UPDATE_TEXT,
                    `Les produits offerts ont bien été modifiés.`
                );
                setStateObj({ isLoading: false, isOpenProducts: false, openPoint: null, updateVersions: true });
            } catch (e) {
                setStateObj({ isLoading: false });
            }
        }
    }
};

export const getFilteredAndSortedProducts = (stateObj) => {
    const { program = {} } = stateObj.newVersion;
    const selectedProducts = _.reduce(program, (point, prg) => {
        if (prg?.points !== stateObj.openPoint) {
            return { ...point, ...prg?.products };
        }
        return point;
    }, {});

    if (!stateObj?.openPoint) return [];

    return stateObj.commonProducts.map(section => ({
        ...section,
        products: section.products
            .filter(product => !selectedProducts[product.key])
            .map(product => ({
                ...product,
                selected: program[stateObj.openPoint]?.products &&
                    _.keys(program[stateObj.openPoint]?.products)?.includes(product.key)
            }))
            .sort((a, b) => {
                if (b.selected - a.selected !== 0) {
                    return b.selected - a.selected;
                }
                return a.name.localeCompare(b.name);
            })
    })).filter(section => section.products.length > 0);
};
export const getProgram = (programData) => {
    let program = {}
    if (programData && typeof programData === 'object') {
        program = _.keys(programData)
            .filter(key => key !== null && programData[key] !== null)
            .reduce((obj, key) => {
                return { ...obj, [key]: programData[key] };
            }, {});
    }
    return program
}
export const getSortedVersions = (data) => {
    const transformedData = _.keys(data).map((key) => {
        return {
            ...data[key],
            program: getProgram(data[key].program),
        };
    })
    const reducedData = transformedData.reduce((obj, item) => {
        const uniqueKey = item.key;
        return { ...obj, [uniqueKey]: item };
    }, {});
    const sortedVersions = _.keys(reducedData)
        .sort((a, b) => reducedData[a].versionName.localeCompare(reducedData[b].versionName))
        .reduce((obj, cur) => ({ ...obj, [cur]: reducedData[cur] }), {})
    return sortedVersions;
}

export const updateFidelityProgram = async (stateObj, setStateObj) => {

    const newConfiguration = { enabled: !stateObj.enabledProduct, type: PRODUCT_TYPE }

    try {
        setStateObj({ enabledProduct: !stateObj.enabledProduct });
        updateLoyaltyConfiguration(newConfiguration);
        showNotification(
            'light',
            'ltr',
            'primary',
            SUCCESS_UPDATE_TEXT,
            `${!stateObj.enabledProduct ? "L'activation" : 'La désactivation'} du programme de fidélité par produit a été effectuée avec succès.`

        )
    } catch (e) {
        console.error(JSON.stringify(e, null, 2));

    }

};
export const getAllLoyaltyProgram = async (stateObj, setStateObj) => {
    const data = (await getLoyaltyPrograms()) || {};
    const sortedVersions = getSortedVersions(data);
    setStateObj({
        versions: sortedVersions,
        version: sortedVersions[stateObj.version?.key] || {},
        newVersion: sortedVersions[stateObj.version?.key] || {},
        originalVersion: sortedVersions[stateObj.version?.key] || {},
        updateVersions: false
    })


}